 import React from "react"; 
 import { HiOutlineViewList } from 'react-icons/hi'; 
 import './style.css'; 
 let PurchDesAllignment=(props)=> { 
   return(
  <div>
    <nav class="navbar navbar-expand-lg py-3">
      <div class="container">
        <a href="#" class="navbar-brand">
          <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" /> <span className="text-uppercase font-weight-bold">Company</span>
        </a>
        <button id='navResponsiveButton' type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span className="navbar-toggler-icon"></span> 
          <HiOutlineViewList size={30} id='threebutt' />
        </button>
        <div id="navbarSupportedContent" className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active"><a href="#" className="nav-link"  onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Services</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >About </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Contact </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" id='cas-link'>Case Studies</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link"  onClick={()=>props.history.push('/signin')}      >Signin</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div id="centerME">
      <div className="boxStAc">
        <h4 id="h4">
  Purchase Descision Allignment ScoreCard
  </h4>
        <br></br>
        <h6 id="h6">
  Purchase decision alignment informs about customer's interest in paying for your solution. And overall alignment in adoption and financial and other support to the initiative
  
  </h6>
        <h5 id="h6">
  Whose problem are you solving? Check all they apply from below
  </h5>
        <div style={{width: '100%',display: 'flex',alignItems: 'flex-start',justifyContent: 'flex-start',flexDirection: 'column',flexWrap: 'wrap',marginTop:20,paddingLeft:20}}>
          <div style={{minWidth:200,display: 'flex',alignItems: 'center',justifyContent: 'space-between'}}>
            <h6 style={{fontWeight: '700',color: 'grey'}}>
  Coustomer
  
  </h6>
            <input type="checkbox"></input>
          </div>
          <div style={{minWidth:200,display: 'flex',alignItems: 'center',justifyContent: 'space-between'}}>
            <h6 style={{fontWeight: '700',color: 'grey'}}>
  Actor
  
  </h6>
            <input type="checkbox"></input>
          </div>
          <div style={{minWidth:200,display: 'flex',alignItems: 'center',justifyContent: 'space-between'}}>
            <h6 style={{fontWeight: '700',color: 'grey'}}>
  StakeHolder
  
  </h6>
            <input type="checkbox"></input>
          </div>
          <div style={{minWidth:200,display: 'flex',alignItems: 'center',justifyContent: 'flex-start',flexDirection: 'row',flexWrap: 'wrap',marginTop:10}}>
            <p style={{fontSize:14,fontWeight: 'bold',width:185,marginTop:20}}>Purchase Descision Store</p>
            <input type='text' style={{padding:4,marginTop:10,borderRadius:4,borderColor: 'transparent',outline: 'none',color: '#666B6E',width:240}}></input>
          </div>
        </div>
        <div id="flexLef">
          <button className="button2" onClick={()=>props.history.push('/cruxImpact')} id='BackNext'>Back</button>
          <button className="button2" onClick={()=>props.history.push('/RevenewScore')} id='BackNext'>Next</button>
        </div>
      </div>
    </div>
  </div>) } 
  export default PurchDesAllignment;